import { endpoints } from "constants/constants";
import { OrganizationFlat } from "../types/Organization";

export interface GetOrganizationsFlatRequestParams {
    outputChildren?: false,
    outputGroups?: false,
    outputRoles?: false,
    outputPermissions?: false,
    pageSize?: number,
    ids?: string[]
}

let cachedData;
let cachedParams;
let oneLoad = true;
const updateQueue: any[] = [];

export const onGetOrganizationsFlat = async (bodyParams: GetOrganizationsFlatRequestParams, setData, setIsLoading) => {
    updateQueue.push(setData);
    if(cachedData && bodyParams === cachedParams) {
        setData(cachedData);
        setIsLoading(false);
        return;
    }
    if(oneLoad) {
        oneLoad = false;
        const token = localStorage.getItem('authBearerToken');
        setIsLoading(true);
        try {
            const response:
                | any
                | {
                ok: any;
                status: any;
                json: any;
            } = await fetch(`${process.env.REACT_APP_API_BASE_PATH + endpoints.ORGANIZATIONS_FLAT}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(bodyParams)
            });
            const json = await response.json();
            if(json && json?.matches) {
                const output: OrganizationFlat[] = [];
                json.matches.forEach((item) => {
                    output.push({
                        name: item?.name,
                        id: item?.id,
                        disabled: item?.disabled,
                        status: item?.status,
                        parent: item?.parent,
                        links: item?.links,
                        type: item?.type,
                        positionType: item?.positionType
                    })
                })
                cachedData = output;
                cachedParams = bodyParams;
                updateQueue.forEach((item) => item(output));
            }
            setIsLoading(false);
        } catch (error: any) {
            console.error('Error fetching organizations flat data:', error);
        }
        oneLoad = true;
    }
}